import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import {Button, Progress} from 'antd'
import {Link} from 'react-router-dom'
import {strVal} from '../../../modules/Utils'
import UpperCaseCell from '../../../elements/Table/Cells/UpperCaseCell'

function ProjectList(props) {
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      zIndex: -10,
      Cell: ({value, original}) => {
        return (
          <Link
            to={{
              pathname: `/programs/${strVal(original, 'parent').replace(
                'projects/',
                '',
              )}/projects/${original._key}/view`,
            }}>
            {value}
          </Link>
        )
      },
    },
    {
      Header: 'Title',
      accessor: 'project.title',
      zIndex: -9,
    },
    {
      Header: 'Type',
      accessor: 'project.projectType',
      Cell: UpperCaseCell,
    },
    {
      Header: 'Category',
      accessor: 'project.category',
      Cell: UpperCaseCell,
    },
    {
      Header: 'Status',
      accessor: 'status',
      zIndex: 999,
    },
    {
      Header: 'Company',
      accessor: 'project.company.fn',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Cost Center',
      accessor: 'project.costCenter',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Sales Contract',
      accessor: 'project.salesContract',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Department',
      accessor: 'project.department',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Start Dates',
      accessor: 'project.startDate',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'End Date',
      accessor: 'project.endDate',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Completion',
      accessor: 'completion',
      Cell: ({value}) => {
        const progressColor =
          value > 40 && value < 100
            ? '#154DE1'
            : value === 100
            ? '#15E16F'
            : '#E13915'
        return (
          <Progress percent={value} size="small" strokeColor={progressColor} />
        )
      },
    },
  ]
  const {list, fetch, fetching, onShow} = props

  const NewProjectButton = () => (
    <Button
      disabled={fetching}
      type="primary"
      icon={'plus'}
      size={'small'}
      onClick={onShow}>
      New
    </Button>
  )
  return (
    <CustomTable
      columns={columns}
      CreateButton={() => <NewProjectButton />}
      data={list}
      fetch={fetch}
      fetching={fetching}
      show={{extraColumns: true}}
    />
  )
}

ProjectList.propTypes = {}
ProjectList.defaultProps = {}

export default ProjectList
